import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // Everything else
  {
    path: '/',
    name: 'ConfiguraterLevel1RedirectLink',
    redirect: '/fertige',
    meta: {
      layout: 'Configurator'
    }
  },
  {
    path: '/b2b',
    name: 'ConfiguraterLevel1RedirectLinkB2B',
    redirect: '/fertige',
    meta: {
      layout: 'Configurator'
    }
  },
  {
    path: '/b2c',
    name: 'ConfiguraterLevel1RedirectLinkB2C',
    redirect: '/fertige',
    meta: {
      layout: 'Configurator'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/fertige',
    alias: ['/b2b/fertige', '/b2c/fertige'],
    name: 'ConfiguraterLevel1DirectLink',
    component: () => import('../views/step1/ConfiguratorLevel1Shared.vue'),
    meta: {
      layout: 'Configurator'
    }
  },
  {
    path: '/fertige/:boxId',
    alias: ['/b2b/fertige/:boxId', '/b2c/fertige/:boxId'],
    name: 'ConfiguraterLevel1DirectLinkProduct',
    component: () => import('../views/PresentPage.vue'),
    meta: {
      layout: 'NoContainer'
    }
  },
  {
    path: '/fertige/:boxId/:product',
    alias: ['/b2b/fertige/:boxId/:product', '/b2c/fertige/:boxId/:product'],
    name: 'CatalogPresentPageProductDetail',
    component: () => import('../views/PresentPage.vue'),
    meta: {
      layout: 'NoContainer'
    }
  },
  {
    path: '/zusammenstellen',
    alias: ['/b2b/zusammenstellen', '/b2c/zusammenstellen'],
    name: 'ConfiguraterLevel3DirectLink',
    component: () => import('../views/step1/ConfiguratorLevel3Shared.vue'),
    meta: {
      layout: 'Configurator'
    }
  },
  {
    path: '/zusammenstellen/:mod/Details',
    alias: ['/b2b/zusammenstellen/:mod/Details', '/b2c/zusammenstellen/:mod/Details'],
    name: 'ConfiguraterLevel3ModalProduct',
    component: () => import('../views/step1/ConfiguratorLevel3Shared.vue'),
    meta: {
      layout: 'Configurator'
    }
  },
  {
    path: '/zusammenfassung',
    alias: ['/b2b/zusammenfassung', '/b2c/zusammenfassung'],
    name: 'Confirmation',
    component: () => import('../views/Configurator/Confirmation.vue'),
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/zusammenfassung/details/:product',
    alias: ['/b2b/zusammenfassung/details/:product', '/b2c/zusammenfassung/details/:product'],
    name: 'ConfirmModalProduct',
    component: () => import('../views/Configurator/Confirmation.vue'),
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/weihnachtspraesente',
    redirect: '/fertige'
  },
  {
    path: '/weihnachtspraesente/:id',
    redirect: '/fertige'
  },
  {
    path: '/weihnachtspraesente/:id/deliveryModal',
    redirect: '/fertige'
  },
  {
    path: '/weihnachtspraesente/:id/:product',
    redirect: '/fertige'
  },
  {
    path: '/b2b/weihnachtspraesente',
    redirect: '/fertige'
  },
  {
    path: '/b2b/weihnachtspraesente/:id',
    redirect: '/fertige'
  },
  {
    path: '/b2b/weihnachtspraesente/:id/deliveryModal',
    redirect: '/fertige'
  },
  {
    path: '/b2b/weihnachtspraesente/:id/:product',
    redirect: '/fertige'
  },

  // Proposal Page
  {
    path: '/angebot/:prop',
    name: 'OldProposalPage',
    component: () => import('../views/ProposalPageLegacy.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/proposal/:id(\\d+)',
    name: 'ProposalPage',
    component: () => import('../views/ProposalPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/proposal/:id(\\d+)/delivery',
    name: 'ProposalPageDeliveryDetail',
    component: () => import('../views/ProposalPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/proposal/:id(\\d+)/:productId(\\d+)',
    name: 'ProposalPageProductDetail',
    component: () => import('../views/ProposalPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  // Customer's Landing Page
  {
    path: '/business/:id',
    alias: ['/b2b/business/:id', '/b2c/business/:id'],
    name: 'CustomerLandingPage',
    component: () => import('../views/CustomerLandingPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/business/:id(\\d+)/delivery',
    alias: ['/b2b/business/:id(\\d+)/delivery', '/b2c/business/:id(\\d+)/delivery'],
    name: 'CustomerLandingPageDeliveryDetail',
    component: () => import('../views/CustomerLandingPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/business/:id(\\d+)/:productId(\\d+)',
    alias: ['/b2b/business/:id(\\d+)/:productId(\\d+)', '/b2c/business/:id(\\d+)/:productId(\\d+)'],
    name: 'CustomerLandingPageProductDetail',
    component: () => import('../views/CustomerLandingPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  {
    path: '/anlaesse/:name/:productId?',
    redirect: '/'
  },
  {
    path: '/b2b/anlaesse/:name/:productId?',
    redirect: '/b2b'
  },
  {
    path: '/admin/produktersetzung',
    name: 'AdminProductReplacer',
    component: () => import('../views/Admin/ProductReplacer.vue'),
    meta: {
      layout: 'Empty'
    }
  },
  // Selfservice
  {
    path: '/selfservice/:orderId',
    name: 'Selfservice',
    component: () => import('../views/Selfservice.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  // AddressService
  {
    path: '/addressinputservice/:key',
    name: 'AddressInputService',
    component: () => import('../views/AddressInputService.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },
  // Legacy URLs redirection
  {
    path: '/konfigurator/:level',
    redirect: '/:level'
  },
  {
    path: '/:customerType/konfigurator/:level',
    redirect: '/:customerType/:level'
  },
  {
    path: '/themen/*/:id',
    redirect: '/fertige/:id',
  },
  {
    path: '/:customerType/themen/*/:id',
    redirect: '/:customerType/fertige/:id'
  },
  {
    path: '/themen/*/*',
    redirect: '/fertige'
  },
  {
    path: '/themen/*/*/:id',
    redirect: '/fertige/:id'
  },
  {
    path: '/:customerType/themen/*/*/:id',
    redirect: '/:customerType/fertige/:id'
  },
  {
    path: '/themen/*/*',
    redirect: '/fertige'
  },
  {
    path: '/:customerType/themen/*/*',
    redirect: '/fertige'
  },
  {
    path: '/themen/*',
    redirect: '/fertige'
  },
  {
    path: '/:customerType/themen/*',
    redirect: '/fertige'
  },

  {
    path: '/pages/:slug',
    alias: ['/b2b/pages/:slug', '/b2c/pages/:slug'],
    name: 'ContentPage',
    component: () => import('../views/ContentPage.vue'),
    props: true,
    meta: {
      layout: 'Empty'
    }
  },

  // Catch all (allegedly not found)
  {
    path: '/*',
    alias: '/404',
    meta: {
      layout: 'Configurator',
      error: 404
    },
    component: () => import('../views/Error.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  //   base: process.env.BASE_URL,
  base: '/praesente/',
  routes,
  beforeEach(to, from) {
    return to !== from;
  },
  scrollBehavior(to, from, savedPosition) {
    if (
      to.name === 'Confirmation' ||
      (to.name === 'ConfiguraterLevel1DirectLink' && from.name !== 'ConfiguraterLevel1DirectLinkProduct') ||
      (to.name === 'ConfiguraterLevel3DirectLink' && from.name !== 'ConfiguraterLevel3ModalProduct') ||
      (to.name === 'ConfiguraterLevel1DirectLinkProduct' && from.name !== 'CatalogPresentPageProductDetail')
    ) {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    }

    // if (to.hash) {
    //   return {
    //     selector: to.hash
    //   };
    // }

    return savedPosition;
  }
});

export default router;
